module.exports = __webpack_public_path__ + "img/Angola.0f194e6e.gif";